import { useRoute } from 'shared/src/hooks/useRoute';
import type { ScreensPageParamList } from '../Navigator';

export const useScreensRoute = <Key extends keyof ScreensPageParamList>() =>
  useRoute<ScreensPageParamList, Key>();
